<template>
    <p class="m-0 pt-1">
        <slot />
    </p>
</template>

<script>
export default {
    name: 'TextLineContainer',
}
</script>
